import { Request } from '../../httpClient/serverApi/requests/Request';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { IFavoriteParams } from '../../spacesPlatform/utils/actionParams';

export let RecentlyViewedObjectType = {
  View: 'view',
  Workbook: 'workbook',
  Metric: 'metric',
  PublishedConnection: 'virtualConnection',
  Flow: 'flow',
  Simulation: 'simulation'
};

export class MarkRecentlyViewedRequest extends Request<IFavoriteParams, IResult> {
  constructor(params: IFavoriteParams) {
    super('markRecentlyViewed', params);
  }
}
